import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatTabBody } from "@angular/material/tabs";
import { map, Observable } from "rxjs";
import { CommonWebService, UserHttpService, HttpResponse, AddActivities, ActivityList, DeleteActivity } from "../public-api";

@Injectable({
    providedIn: 'root'
})
export class ManageActivitiesService {
    constructor(
        private http: HttpClient,
        private commonService: CommonWebService,
        private userSessionService: UserHttpService
    ) { }

    public addActivities(body:AddActivities, isEdit: boolean = false):Observable<HttpResponse<AddActivities>>{
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('comments', body.comments);
        formData.append('main_activity_id', body.main_activity_id);
        formData.append('sub_activity', body.sub_activity);

        if(isEdit && body.activity_id){
            formData.append('activity_id', body.activity_id ? body.activity_id : '');
        }

        return this.http.post<HttpResponse<AddActivities>>(`activities/AddActivity` , formData)
    }

    public activityList(body:ActivityList, isEdit: boolean = false):Observable<HttpResponse<ActivityList>>{
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('activity_id', body.activity_id ? body.activity_id : '');

        return this.http.post<HttpResponse<ActivityList>>(`activities/AddActivity/getActivitylist` , formData)
    }
   

    public deleteActivity(activity_id:string):Observable<HttpResponse<DeleteActivity>> {
        let formData = new FormData();
        formData.append('user_id' , this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id" , this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('activity_id' , activity_id ? activity_id : '');
        return this.http.post<HttpResponse<DeleteActivity>>(`activities/AddActivity/delete_activity` , formData)
    }
    

    public activityDetail(activity_id:string){
        let formData = new FormData();
        formData.append('user_id' , this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id" , this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('activity_id' , activity_id ? activity_id : '');
        return this.http.post(`activities/AddActivity/getactivityview` , formData)
    }
}  